<script lang="ts">
	import { resolve } from '$app/paths';
	import Button from '#lib/components/ui/Button.svelte';
	import Margin from '#lib/components/ui/Margin.svelte';
	import { gameState, useCases } from '#lib/root.ts';
	import { ROUTES, type InternalRoute } from '#lib/ui/routes.ts';
	import { slidefade } from '#lib/utils/animations.ts';

	let hasPreviousGame = $state(false);
	let loaded = $state(false);

	type Button = {
		text: string;
		route: InternalRoute;
		enabled: boolean;
		onClick?: () => void;
	};

	const buttons: Button[] = $derived(
		!loaded
			? []
			: [
					{ text: 'New Game', route: ROUTES.GAME, enabled: true, onClick: () => gameState.reset() },
					{ text: 'Continue Game', route: ROUTES.GAME, enabled: hasPreviousGame },
					{ text: 'Rules', route: ROUTES.RULES, enabled: true },
					{ text: 'Settings', route: ROUTES.SETTINGS, enabled: true }
				].filter((button) => button.enabled)
	);

	$effect(() => {
		hasPreviousGame = useCases.checkExistingGame.execute();
		loaded = true;
	});
</script>

{#each buttons as button, index (button.text)}
	<a
		in:slidefade={{ delay: index * 200, duration: 2000 }}
		href={resolve(button.route)}
		onclick={button.onClick}
	>
		<Button wide>{button.text}</Button>
	</a>
	{#if index < buttons.length - 1}
		<Margin bottom={4} />
	{/if}
{/each}
